import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  IFormReview,
  RequiredDynamicItemBaseComponent,
} from '@ups/xplat/dynamic-render';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-ai-coaching-results',
  templateUrl: './ai-coaching-results.component.html',
  styleUrls: ['./ai-coaching-results.component.scss'],
  standalone: false,
})
export class AiCoachingResultsComponent
  extends RequiredDynamicItemBaseComponent
  implements OnInit
{
  formReview: IFormReview | null = null;
  feedback: string | null = null;
  likelihood: number | null = null;
  likelihoodReason: string | null = null;
  impact: number | null = null;
  impactReason: string | null = null;
  value: number | null = null;
  valueReason: string | null = null;
  selectedButton: string | null = null;
  reviewDate: string | null = null;
  isAiCoachingSubmitted = false;
  recommendedForm: string | null = null;
  reclassifyReason: string | null = null;
  recommendReclassify = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.config.options.dynamicContainerResponseId) {
      this.dynamicService
        .getFormReview(
          this.config.options.dynamicContainerResponseId,
          'aicoach'
        )
        .toPromise()
        .then((d) => {
          this.formReview = d;
          this.selectedButton = d.FormReviewStatusName?.toLowerCase().replace(
            /\s+/g,
            ''
          );
          this.likelihood = d.Likelihood;
          this.impact = d.Impact;
          this.value = d.Value;
          this.likelihoodReason = d.LikelihoodReason;
          this.impactReason = d.ImpactReason;
          this.valueReason = d.ValueReason;
          this.feedback = d.Response;
          this.reviewDate = d.ReviewDate;
          this.recommendedForm = d.RecommendedForm;
          this.reclassifyReason = d.ReclassifyReason;
          this.recommendReclassify = d.RecommendReclassify;
          // OnPush: these async assignments are this subclass's own template
          // state, not the config.options mutations the base plumbs, so mark
          // dirty here or the results view stays empty after the HTTP returns.
          this.cdr?.markForCheck();
        });
    }
  }

  submitAiCoaching() {
    this.isAiCoachingSubmitted = true;

    this.dynamicService
      .aiCoach(this.config.options.dynamicContainerResponseId, true)
      .subscribe({
        next: (d) => {
          this.likelihood = d.likelihood;
          this.impact = d.impact;
          this.value = d.value;
          this.recommendedForm = d.reclassify;
          this.reclassifyReason = d.reclassifyReason;
          this.recommendReclassify = d.reclassify !== null;
          this.feedback = d.feedback;
          this.selectedButton = d.reviewStatus
            ?.toLowerCase()
            .replace(/\s+/g, '');
          this.likelihoodReason = d.likelihoodReason;
          this.impactReason = d.impactReason;
          this.valueReason = d.valueReason;
          this.cdr?.markForCheck();
        },
        error: (error) => {
          this.isAiCoachingSubmitted = false;
          console.error('Error in AI coaching:', error);
          this.cdr?.markForCheck();
        },
        complete: () => {
          this.isAiCoachingSubmitted = true;
          this.cdr?.markForCheck();
        },
      });
  }
}
